import { Component } from '@angular/core';

@Component({
    selector: 'app-precos',
    templateUrl: './precos.component.html',
    styleUrls: ['./precos.component.css']
})

export class PrecosComponent {
}

